import { Plus, Truck, Bell, FileCheck, Wallet, MapPin, ChevronLeft } from "lucide-react";
import { IconBox, Plate } from "@/pages/preview/AdminMock";

const TILES = [[Truck, "نقلاتي", "2 قيد التنفيذ", "blue"], [Bell, "إشعاراتي", "1 جديد", "red"], [FileCheck, "مستنداتي", "الكل ساري", "green"], [Wallet, "حسابي", "الرصيد 15.000", "amber"]];

export default function DriverMock({ t }) {
  return (
    <div className={`w-[340px] max-w-full mx-auto rounded-[2.5rem] border-[10px] border-black overflow-hidden shadow-2xl ${t.page}`} data-testid={`preview-driver-${t.id}`}>
      <div className={`p-5 pb-6 text-white ${t.driverHero}`}>
        <div className="flex items-center gap-2 mb-4"><span className={`w-9 h-9 rounded-xl flex items-center justify-center text-sm font-black ${t.logo}`}>AO</span><span className="text-sm font-bold">المحيط الأطلسي</span></div>
        <div className="text-sm opacity-70">مرحباً</div>
        <div className="text-2xl font-black" style={{ fontFamily: "var(--pv-head)" }}>محمد العنزي</div>
        <div className="mt-2 flex items-center gap-2 text-sm"><span className="opacity-70">ونش •</span><Plate t={t} adm="21" plate="45454" /></div>
      </div>
      <div className="p-4 space-y-3">
        <button className={`w-full p-5 flex items-center justify-between text-xl ${t.btn}`}><span style={{ fontFamily: "var(--pv-head)" }}>نقلة جديدة</span><span className="w-11 h-11 rounded-full bg-black/10 flex items-center justify-center"><Plus className="w-7 h-7" /></span></button>
        <div className="grid grid-cols-2 gap-3">
          {TILES.map(([I, l, s, tone]) => (
            <div key={l} className={`p-4 min-h-[118px] flex flex-col justify-between ${t.tile}`}>
              <IconBox t={t} tone={tone} Icon={I} size={46} iconSize={24} />
              <div><div className="text-lg font-black" style={{ fontFamily: "var(--pv-head)" }}>{l}</div><div className={`text-xs ${t.muted}`}>{s}</div></div>
            </div>
          ))}
        </div>
        <div className={`p-3 flex items-center gap-3 ${t.tile}`}><IconBox t={t} tone="teal" Icon={MapPin} size={38} iconSize={18} />
          <span className="text-sm flex-1">الموقع يُسجَّل فقط عند تنفيذ إجراءات العمل</span><ChevronLeft className={`w-4 h-4 ${t.muted}`} /></div>
      </div>
    </div>
  );
}
